import { Typography } from '@mui/material';

const MessageUsersAutoMassDmDescription = () => {
    return (
        <>
            <Typography variant="body1" gutterBottom>
                Break free from the limitations of OnlyFans’ built-in Mass DM system with Auto Mass DM. Schedule unlimited Mass DMs, set up
                repeats and unsends, and automatically add purchasers to lists—all with ease!
            </Typography>
            <Typography variant="body1" gutterBottom>
                While the 50 Mass DMs per 24-hour limit still applies, Auto Mass DM lets you plan ahead, eliminating the hassle of manually
                scheduling the same message over and over again.
            </Typography>
            <Typography variant="body1" gutterBottom>
                Each Mass DM can use one of four content types. Manual lets you compose the message yourself, including media, PPV pricing,
                and creator tags. Album picks random media from a vault album when the Mass DM is sent, with optional captions from your
                caption library. Template randomly chooses from selected content-inventory templates at send time, using each
                template&apos;s message, media, pricing, and send-to/exclude list settings. Caption sends the least-used caption from your
                caption library as a free text-only Mass DM, with no media attached.
            </Typography>
        </>
    );
};

export default MessageUsersAutoMassDmDescription;
